import React from 'react';
import { Page, Text, Document, StyleSheet, Image } from '@react-pdf/renderer';
import { format, parseISO } from 'date-fns';
import { fr } from 'date-fns/locale';

function formatDateToFrench(dateString) {
  try {
    const date = parseISO(dateString);

    const formattedDate = format(date, 'eeee d MMMM', { locale: fr });

    return formattedDate;
  } catch (error) {
    console.error("Date invalide", error);
    return "Date invalide";
  }
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#FFFFFF',
    width: "100%",
    padding: 10
  },
  section: {
    width: 200,
    height: 200
  },
  title: {
    fontSize: 13,
    borderBottom: '1px solid black',
    padding: 5,
    fontWeight: 20,
    marginLeft: 100,
  },
  Day1: {
    position: "absolute",
    top: 70,
    left: 20,
    height: 150,
    width: 650,
    display: "flex",
    flexDirection: "column"
  },
  Day2: {
    position: "absolute",
    top: 135,
    left: 0,
    height: 150,
    width: 650
  },
  Day3: {
    position: "absolute",
    top: 255,
    left: 0,
    height: 150,
    width: 650
  },
  Day4: {
    position: "absolute",
    top: 375,
    left: 0,
    height: 150,
    width: 650
  },
  Day5: {
    position: "absolute",
    top: 0,
    left: 0,
    height: 150,
    width: 650
  },
  Day6: {
    position: "absolute",
    top: 135,
    left: 0,
    height: 150,
    width: 650
  },
  Day7: {
    position: "absolute",
    top: 255,
    left: 0,
    height: 150,
    width: 650
  },
  date: {
    fontSize: "7",
    marginTop: 3,
    marginLeft: 3
  },
  leftPart: {
    width: 145,
  },
  rightPart: {
    width: 495,
  },
  check: {
    width: 15,
    height: 15,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    position: "absolute",
    top: 0,
    left: 0
  },
  no_left_check: {
    width: 15,
    height: 15,
    borderRight: "1px solid black",
    borderBottom: "1px solid black",
    position: "absolute",
    top: 0,
    left: 0
  },
  small_check: {
    borderLeft: "1px solid black",
    width: 20,
    height: 21
  },
  no_left_small_check: {
    width: 20,
    height: 21
  },
  checkBox: {
    display: "flex",
    flexDirection: "column",
    fontSize: 9,
    width: 160,
    justifyContent: "center",
    paddingLeft: "5px",
    paddingRight: "5px"
  },
  long_checkBox: {
    display: "flex",
    flexDirection: "column",
    fontSize: 9,
    borderLeft: "1px solid black",
    width: 400,
    justifyContent: "center"
  },
  checkLabel: {
    marginLeft: 2
  },
  MenuA: {
    borderLeft: "1px solid black",
    fontSize: "12",
    textAlign: "center",
    fontWeight: 2000,
    width: 160
  },
  no_left_MenuA: {
    fontSize: "12",
    textAlign: "center",
    fontWeight: 900,
    width: 160
  },
  MenuB: {
    border: "1px solid black",
    fontSize: "10",
    width: 140,
    textAlign: "center",
  },
  Options: {
    border: "1px solid black",
    fontSize: "10",
    width: 490,
    textAlign: "center",
  },
  Options2: {
    border: "1px solid black",
    fontSize: "10",
    width: 490,
    textAlign: "center",
  },
  content: {
    fontSize: "9",
    textAlign: "center",
    lineHeight: 1.2,
    position: "relative"
  },
  left_content : {
    fontSize: "9",
    textAlign: "left",
    marginLeft: "5"
  },
  optionsList: {
    display: "flex",
    flexDirection: "row"
  },
  line: {
    display: "flex",
    flexDirection: "row",
    border: "1px solid black",
    width: 800,
    justifyContent: "center"
  },
  no_top_line: {
    display: "flex",
    flexDirection: "row",
    width: 800,
    justifyContent: "center",
    borderLeft: "1px solid black",
    borderRight: "1px solid black",
    borderBottom: "1px solid black"
  },
  date_line: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: 800,
    borderRight: "1px solid black",
    borderLeft: "1px solid black",
    borderTop: "1px solid black",
    backgroundColor: "palegreen",
    textAlign: "center",
    fontSize: 15
  },
  no_top_date_line: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: 800,
    borderRight: "1px solid black",
    borderLeft: "1px solid black",
    backgroundColor: "palegreen",
    textAlign: "center",
    fontSize: 15
  },
  vertical_separator: {
    width: 1,
    height: 70,
    borderLeft: "1px solid black"
  }

});

export default function MyDocument(props) {

  return (
    <Document title="menus.pdf">
      <Page size="A4" style={styles.page} orientation="landscape">
      <Image src="/logo.png" style={{height: 60}}/>
        <view style={{padding: "10"}}>
          <Text style={styles.title}> Nom :                             A retourner pour le : <Text style={{color: "red", fontWeight: "bold"}}>Jeudi __/__ | Vendredi __/__ | Samedi __/__ | Lundi __/__</Text></Text>
        </view>
        <Text style={{fontSize: "10", position: "absolute", top: "50", right: "50", width: "30"}}>S{props.value}</Text>
        <view style={styles.Day1}>
          <view style={styles.line}>
            <Text style={styles.no_left_MenuA}>Menu A</Text>
            <Text style={styles.MenuA}>Menu sans viande</Text>
            <Text style={styles.MenuA}>Menu sans poisson</Text>
            <Text style={styles.MenuA}>Menu diabétique</Text>
            <Text style={styles.MenuA}>Menu B</Text>
          </view>
          <Text style={styles.no_top_date_line}>{formatDateToFrench(props.day1.date)}</Text>
          <view style={styles.line}>
            <view style={styles.checkBox}>
              <view style={styles.no_left_check}/>
              <Text style={styles.content}>{props.day1.entreeA}</Text>
              <Text style={styles.content}>{props.day1.platA}</Text>
              <Text style={styles.content}>{props.day1.laitageA}</Text>
              <Text style={styles.content}>{props.day1.dessertA}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day1.entreeSV}</Text>
              <Text style={styles.content}>{props.day1.platSV}</Text>
              <Text style={styles.content}>{props.day1.laitageSV}</Text>
              <Text style={styles.content}>{props.day1.dessertSV}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day1.entreeSP}</Text>
              <Text style={styles.content}>{props.day1.platSP}</Text>
              <Text style={styles.content}>{props.day1.laitageSP}</Text>
              <Text style={styles.content}>{props.day1.dessertSP}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day1.entreeD}</Text>
              <Text style={styles.content}>{props.day1.platD}</Text>
              <Text style={styles.content}>{props.day1.laitageD}</Text>
              <Text style={styles.content}>{props.day1.dessertD}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day1.entreeB}</Text>
              <Text style={styles.content}>{props.day1.platB}</Text>
              <Text style={styles.content}>{props.day1.laitageB}</Text>
              <Text style={styles.content}>{props.day1.dessertB}</Text>
            </view>
          </view>
          <view style={styles.no_top_line}>
            <view style={styles.no_left_small_check}/>
            <view style={styles.long_checkBox}>
              <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Potage : </Text>{props.day1.potage}</Text>
            </view>
            <view style={styles.small_check}/>
            <view style={styles.long_checkBox}>
              <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Dîner léger : </Text>{props.day1.diner}</Text>
            </view>
          </view>
          <view style={styles.Day2}>
            <Text style={styles.date_line}>{formatDateToFrench(props.day2.date)}</Text>
            <view style={styles.line}>
              <view style={styles.checkBox}>
                <view style={styles.no_left_check}/>
                <Text style={styles.content}>{props.day2.entreeA}</Text>
                <Text style={styles.content}>{props.day2.platA}</Text>
                <Text style={styles.content}>{props.day2.laitageA}</Text>
                <Text style={styles.content}>{props.day2.dessertA}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day2.entreeSV}</Text>
                <Text style={styles.content}>{props.day2.platSV}</Text>
                <Text style={styles.content}>{props.day2.laitageSV}</Text>
                <Text style={styles.content}>{props.day2.dessertSV}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day2.entreeSP}</Text>
                <Text style={styles.content}>{props.day2.platSP}</Text>
                <Text style={styles.content}>{props.day2.laitageSP}</Text>
                <Text style={styles.content}>{props.day2.dessertSP}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day2.entreeD}</Text>
                <Text style={styles.content}>{props.day2.platD}</Text>
                <Text style={styles.content}>{props.day2.laitageD}</Text>
                <Text style={styles.content}>{props.day2.dessertD}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day2.entreeB}</Text>
                <Text style={styles.content}>{props.day2.platB}</Text>
                <Text style={styles.content}>{props.day2.laitageB}</Text>
                <Text style={styles.content}>{props.day2.dessertB}</Text>
              </view>
            </view>
            <view style={styles.no_top_line}>
              <view style={styles.no_left_small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Potage : </Text>{props.day2.potage}</Text>
              </view>
              <view style={styles.small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Dîner léger : </Text>{props.day2.diner}</Text>
              </view>
            </view>
          </view>
          <view style={styles.Day3}>
            <Text style={styles.date_line}>{formatDateToFrench(props.day3.date)}</Text>
            <view style={styles.line}>
              <view style={styles.checkBox}>
                <view style={styles.no_left_check}/>
                <Text style={styles.content}>{props.day3.entreeA}</Text>
                <Text style={styles.content}>{props.day3.platA}</Text>
                <Text style={styles.content}>{props.day3.laitageA}</Text>
                <Text style={styles.content}>{props.day3.dessertA}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day3.entreeSV}</Text>
                <Text style={styles.content}>{props.day3.platSV}</Text>
                <Text style={styles.content}>{props.day3.laitageSV}</Text>
                <Text style={styles.content}>{props.day3.dessertSV}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day3.entreeSP}</Text>
                <Text style={styles.content}>{props.day3.platSP}</Text>
                <Text style={styles.content}>{props.day3.laitageSP}</Text>
                <Text style={styles.content}>{props.day3.dessertSP}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day3.entreeD}</Text>
                <Text style={styles.content}>{props.day3.platD}</Text>
                <Text style={styles.content}>{props.day3.laitageD}</Text>
                <Text style={styles.content}>{props.day3.dessertD}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day3.entreeB}</Text>
                <Text style={styles.content}>{props.day3.platB}</Text>
                <Text style={styles.content}>{props.day3.laitageB}</Text>
                <Text style={styles.content}>{props.day3.dessertB}</Text>
              </view>
            </view>
            <view style={styles.no_top_line}>
              <view style={styles.no_left_small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Potage : </Text>{props.day3.potage}</Text>
              </view>
              <view style={styles.small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Dîner léger : </Text>{props.day3.diner}</Text>
              </view>
            </view>
          </view>
          <view style={styles.Day4}>
            <Text style={styles.date_line}>{formatDateToFrench(props.day4.date)}</Text>
            <view style={styles.line}>
              <view style={styles.checkBox}>
                <view style={styles.no_left_check}/>
                <Text style={styles.content}>{props.day4.entreeA}</Text>
                <Text style={styles.content}>{props.day4.platA}</Text>
                <Text style={styles.content}>{props.day4.laitageA}</Text>
                <Text style={styles.content}>{props.day4.dessertA}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day4.entreeSV}</Text>
                <Text style={styles.content}>{props.day4.platSV}</Text>
                <Text style={styles.content}>{props.day4.laitageSV}</Text>
                <Text style={styles.content}>{props.day4.dessertSV}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day4.entreeSP}</Text>
                <Text style={styles.content}>{props.day4.platSP}</Text>
                <Text style={styles.content}>{props.day4.laitageSP}</Text>
                <Text style={styles.content}>{props.day4.dessertSP}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day4.entreeD}</Text>
                <Text style={styles.content}>{props.day4.platD}</Text>
                <Text style={styles.content}>{props.day4.laitageD}</Text>
                <Text style={styles.content}>{props.day4.dessertD}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day4.entreeB}</Text>
                <Text style={styles.content}>{props.day4.platB}</Text>
                <Text style={styles.content}>{props.day4.laitageB}</Text>
                <Text style={styles.content}>{props.day4.dessertB}</Text>
              </view>
            </view>
            <view style={styles.no_top_line}>
              <view style={styles.no_left_small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Potage : </Text>{props.day4.potage}</Text>
              </view>
              <view style={styles.small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Dîner léger : </Text>{props.day4.diner}</Text>
              </view>
            </view>
          </view>
        </view>
      </Page>
      <Page size="A4" style={styles.page} orientation="landscape">
        <view style={styles.Day1}>
          <view style={styles.line}>
            <Text style={styles.no_left_MenuA}>Menu A</Text>
            <Text style={styles.MenuA}>Menu sans viande</Text>
            <Text style={styles.MenuA}>Menu sans poisson</Text>
            <Text style={styles.MenuA}>Menu diabétique</Text>
            <Text style={styles.MenuA}>Menu B</Text>
          </view>
          <Text style={styles.date_line}>{formatDateToFrench(props.day5.date)}</Text>
          <view style={styles.line}>
            <view style={styles.checkBox}>
              <view style={styles.no_left_check}/>
              <Text style={styles.content}>{props.day5.entreeA}</Text>
              <Text style={styles.content}>{props.day5.platA}</Text>
              <Text style={styles.content}>{props.day5.laitageA}</Text>
              <Text style={styles.content}>{props.day5.dessertA}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day5.entreeSV}</Text>
              <Text style={styles.content}>{props.day5.platSV}</Text>
              <Text style={styles.content}>{props.day5.laitageSV}</Text>
              <Text style={styles.content}>{props.day5.dessertSV}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day5.entreeSP}</Text>
              <Text style={styles.content}>{props.day5.platSP}</Text>
              <Text style={styles.content}>{props.day5.laitageSP}</Text>
              <Text style={styles.content}>{props.day5.dessertSP}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day5.entreeD}</Text>
              <Text style={styles.content}>{props.day5.platD}</Text>
              <Text style={styles.content}>{props.day5.laitageD}</Text>
              <Text style={styles.content}>{props.day5.dessertD}</Text>
            </view>
            <view style={styles.vertical_separator} />
            <view style={styles.checkBox}>
              <view style={styles.check}/>
              <Text style={styles.content}>{props.day5.entreeB}</Text>
              <Text style={styles.content}>{props.day5.platB}</Text>
              <Text style={styles.content}>{props.day5.laitageB}</Text>
              <Text style={styles.content}>{props.day5.dessertB}</Text>
            </view>
          </view>
          <view style={styles.no_top_line}>
            <view style={styles.no_left_small_check}/>
            <view style={styles.long_checkBox}>
              <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Potage : </Text>{props.day5.potage}</Text>
            </view>
            <view style={styles.small_check}/>
            <view style={styles.long_checkBox}>
              <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Dîner léger : </Text>{props.day5.diner}</Text>
            </view>
          </view>
          <view style={styles.Day6}>
            <Text style={styles.date_line}>{formatDateToFrench(props.day6.date)}</Text>
            <view style={styles.line}>
              <view style={styles.checkBox}>
                <view style={styles.no_left_check}/>
                <Text style={styles.content}>{props.day6.entreeA}</Text>
                <Text style={styles.content}>{props.day6.platA}</Text>
                <Text style={styles.content}>{props.day6.laitageA}</Text>
                <Text style={styles.content}>{props.day6.dessertA}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day6.entreeSV}</Text>
                <Text style={styles.content}>{props.day6.platSV}</Text>
                <Text style={styles.content}>{props.day6.laitageSV}</Text>
                <Text style={styles.content}>{props.day6.dessertSV}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day6.entreeSP}</Text>
                <Text style={styles.content}>{props.day6.platSP}</Text>
                <Text style={styles.content}>{props.day6.laitageSP}</Text>
                <Text style={styles.content}>{props.day6.dessertSP}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day6.entreeD}</Text>
                <Text style={styles.content}>{props.day6.platD}</Text>
                <Text style={styles.content}>{props.day6.laitageD}</Text>
                <Text style={styles.content}>{props.day6.dessertD}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day6.entreeB}</Text>
                <Text style={styles.content}>{props.day6.platB}</Text>
                <Text style={styles.content}>{props.day6.laitageB}</Text>
                <Text style={styles.content}>{props.day6.dessertB}</Text>
              </view>
            </view>
            <view style={styles.no_top_line}>
              <view style={styles.no_left_small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Potage : </Text>{props.day6.potage}</Text>
              </view>
              <view style={styles.small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Dîner léger : </Text>{props.day6.diner}</Text>
              </view>
            </view>
          </view>
          <view style={styles.Day7}>
            <Text style={styles.date_line}>{formatDateToFrench(props.day7.date)}</Text>
            <view style={styles.line}>
              <view style={styles.checkBox}>
                <view style={styles.no_left_check}/>
                <Text style={styles.content}>{props.day7.entreeA}</Text>
                <Text style={styles.content}>{props.day7.platA}</Text>
                <Text style={styles.content}>{props.day7.laitageA}</Text>
                <Text style={styles.content}>{props.day7.dessertA}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day7.entreeSV}</Text>
                <Text style={styles.content}>{props.day7.platSV}</Text>
                <Text style={styles.content}>{props.day7.laitageSV}</Text>
                <Text style={styles.content}>{props.day7.dessertSV}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day7.entreeSP}</Text>
                <Text style={styles.content}>{props.day7.platSP}</Text>
                <Text style={styles.content}>{props.day7.laitageSP}</Text>
                <Text style={styles.content}>{props.day7.dessertSP}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day7.entreeD}</Text>
                <Text style={styles.content}>{props.day7.platD}</Text>
                <Text style={styles.content}>{props.day7.laitageD}</Text>
                <Text style={styles.content}>{props.day7.dessertD}</Text>
              </view>
              <view style={styles.vertical_separator} />
              <view style={styles.checkBox}>
                <view style={styles.check}/>
                <Text style={styles.content}>{props.day7.entreeB}</Text>
                <Text style={styles.content}>{props.day7.platB}</Text>
                <Text style={styles.content}>{props.day7.laitageB}</Text>
                <Text style={styles.content}>{props.day7.dessertB}</Text>
              </view>
            </view>
            <view style={styles.no_top_line}>
              <view style={styles.no_left_small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Potage : </Text>{props.day7.potage}</Text>
              </view>
              <view style={styles.small_check}/>
              <view style={styles.long_checkBox}>
                <Text style={styles.left_content}><Text style={{fontWeight: 700}}>Dîner léger : </Text>{props.day7.diner}</Text>
              </view>
            </view>
          </view>
        </view>
      </Page>
    </Document>
  )
};